module.exports = __webpack_public_path__ + "img/提示.c9ade772.png";